import script from "./PackageContent.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageContent.vue?vue&type=script&setup=true&lang=js"

import "./PackageContent.vue?vue&type=style&index=0&id=5516929e&scoped=true&lang=css"
import "./PackageContent.vue?vue&type=style&index=1&id=5516929e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5516929e"]])

export default __exports__